<template>
  <v-layout>
    <v-flex>
      <text-field
        v-model.trim="form.name"
        :rules="vs.form.name"
        :label="adminText('workflowsAll.referral_name_a363eb3', 'Referral name')"
        autofocus
      />
    </v-flex>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'

export default {
  mixins: [WorkflowDisplay],
  name: 'referral-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
}
</script>

<style scoped>
</style>
